import AddLine from '@/assets/icons/ri_add_line.svg?component';
import { Button } from '@/components/atoms/Buttons';
import { Card } from '@/components/atoms/Card';

import Glyph from '../Glyph/Glyph';

import styles from './BoardEmptyState.module.scss';

interface BoardEmptyStateProps {
    title: string;
    description?: string;
    actionLabel: string;
    onAction: () => void;
    /** When set, the action is disabled and this explains why. */
    actionDisabledReason?: string | null;
    /** Id of a visible note explaining a disabled action. */
    actionDescribedBy?: string;
}

/** Shown in place of the board: no cycle at the site yet, or a cycle with no groups. */
export default function BoardEmptyState(props: BoardEmptyStateProps) {
    const { title, description, actionLabel, onAction, actionDisabledReason = null } = props;
    const { actionDescribedBy } = props;

    return (
        <Card padding="none" className={styles.empty}>
            <p className={styles.title}>{title}</p>
            {description && <p className={styles.description}>{description}</p>}
            <Button
                variant="primary"
                icon={<Glyph icon={AddLine} />}
                disabled={actionDisabledReason !== null}
                tooltip={actionDisabledReason ?? undefined}
                aria-describedby={actionDescribedBy}
                onClick={onAction}>
                {actionLabel}
            </Button>
        </Card>
    );
}
